import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';

/**
 * Picture base service
 */
export abstract class PicturesBaseService {
  /**
   * The load / save resource URL
   */
  protected loadSaveResource: string;

  /**
   * The property picture byte resource URL
   */
  protected propertyPictureBytesResource: string;

  /**
  * The property picture byte resource URL
  */
  protected projectPictureBytesResource: string;

  /**
   * Constructor
   * @param appServiceHelper
   * @param httpClient
   * @param loadSaveApi
   * @param pictureBytesResource
   * @param businessObjectType
   * @param dtoFieldName
   */
  constructor(
    protected appServiceHelper: AppServiceHelperService,
    protected httpClient: HttpClient,
    protected loadSaveApi: 'pollux.api'
      | 'pollux.comparables.api'
      | 'pollux.projectValuation.api'
      | 'pollux.reportDesigner.api'
      | 'pollux.settings.api'
      | 'pollux.import.api'
      | 'pollux.data.transformation.api'
      | 'pollux.dataverse.api'
      | 'pollux.argus.integration.api'
      | 'pollux.pix.integration.api'
      | 'pollux.pixwintegration.capforce.api'
      | 'pollux.currencies.api'
      | 'pollux.casemanagement.api'
      | 'pollux.valorem.integration.api',
    protected pictureBytesResource: 'pollux.api'
      | 'pollux.comparables.api'
      | 'pollux.projectValuation.api'
      | 'pollux.reportDesigner.api'
      | 'pollux.settings.api'
      | 'pollux.import.api'
      | 'pollux.data.transformation.api'
      | 'pollux.dataverse.api'
      | 'pollux.argus.integration.api'
      | 'pollux.pix.integration.api'
      | 'pollux.pixwintegration.capforce.api'
      | 'pollux.currencies.api'
      | 'pollux.casemanagement.api'
      | 'pollux.valorem.integration.api',
    protected businessObjectType: string,
    protected dtoFieldName: string
  ) {
    this.loadSaveResource = this.appServiceHelper.getServiceEndpoint(loadSaveApi, businessObjectType);
    this.propertyPictureBytesResource = this.appServiceHelper.getServiceEndpoint(pictureBytesResource, '/picturesexport/pictures/bytes');
    this.projectPictureBytesResource = this.appServiceHelper.getServiceEndpoint(pictureBytesResource, 'projects/picturesexport/pictures/bytes');
  }

  /**
       * Gets a list of all pictures for this property
       * 
       * api/v2/picturesexport/pictures
       * 
       * @returns A list of all pictures for this property
       */
  public getPictures(oid: number): Observable<any> {
    return this.httpClient.get<any>(`${this.loadSaveResource}/picturesexport/pictures?${this.dtoFieldName}=${oid}`);
  }

  /**
   * Deletes a property picture
   * 
   * api/v2/picturesexport/pictures/delete
   * 
   * @param oid The OID of the picture that will be deleted
   */
  public deletePicture(oid: number): Observable<any> {
    return this.httpClient.post<any>(`${this.loadSaveResource}/picturesexport/pictures/delete?oid=${oid}`, {});
  }

  /**
   * Saves and attaches a picture to a property
   * 
   * api/v2/picturesexport/pictures/save
   */
  public savepicture(data: any, oid: number): Observable<any> {
    data[this.dtoFieldName] = oid;
    return this.httpClient.post<any>(`${this.loadSaveResource}/picturesexport/pictures/save`, data);
  }

  /**
   * Gets the picture bytes
   * @param oid
   * @returns
   */
  public getPictureBytes(oid: number): Observable<any> {
    if (this.businessObjectType == 'projects') {
      return this.httpClient.get(`${this.projectPictureBytesResource}?oid=${oid}`, { responseType: 'blob' });
    }
    else {
      return this.httpClient.get(`${this.propertyPictureBytesResource}?oid=${oid}`, { responseType: 'blob' });
    }
  }
}
